import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { portalApi } from "@/lib/portalApi";

export default function PortalListsPage() {
  const [lists, setLists] = useState([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const [ok, setOk] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () =>
    portalApi.lists
      .index()
      .then((data) => setLists(data.mailing_lists))
      .catch((err) => setError(err.message));

  useEffect(() => {
    load();
  }, []);

  async function onCreate(e) {
    e.preventDefault();
    setBusy(true);
    setError("");
    setOk("");
    try {
      await portalApi.lists.create({ name, description });
      setName("");
      setDescription("");
      setOk("List created.");
      await load();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  async function onDelete(id) {
    if (!window.confirm("Delete this list?")) return;
    try {
      await portalApi.lists.destroy(id);
      await load();
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <>
      <h1>Mailing lists</h1>
      <p className="muted">Save and manage recipient lists</p>
      {error && <div className="portal-alert portal-alert--error">{error}</div>}
      {ok && <div className="portal-alert portal-alert--ok">{ok}</div>}

      <div className="portal-card">
        <h2>Create list</h2>
        <form className="portal-form" onSubmit={onCreate}>
          <label>
            Name
            <input required value={name} onChange={(e) => setName(e.target.value)} />
          </label>
          <label>
            Description
            <textarea value={description} onChange={(e) => setDescription(e.target.value)} />
          </label>
          <button className="btn" type="submit" disabled={busy}>
            {busy ? "Saving…" : "Save list"}
          </button>
        </form>
      </div>

      <div className="portal-card">
        <h2>Your lists</h2>
        {lists.length === 0 ? (
          <p className="muted">No lists yet.</p>
        ) : (
          <table className="portal-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Subscribers</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {lists.map((list) => (
                <tr key={list.id}>
                  <td>
                    <Link to={`/portal/lists/${list.id}`} style={{ textDecoration: "underline" }}>
                      {list.name}
                    </Link>
                  </td>
                  <td>{list.subscriber_count}</td>
                  <td>
                    <button type="button" className="btn btn--ghost" onClick={() => onDelete(list.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}
